import { Flex } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled from "styled-components";

export const HeadingText = styled(Text)`
  color: #040222;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.1px;
  max-width: 272px;
  span {
    color: #7c47e1;
  }

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 28px;
  }
`;

export const PageHeadingWithImageWrapper = styled(Flex)`
  z-index:1;
  width: 100%;
  height: 113px;
  ${(props: any) => props.styles}
  // @media(max-width: 768px){
  //   width: 89%;
  // }
`;
